<div class="message-view">
  <img src="images/alert.png"><br />
  <span>{{defaultText.text}}</span>
</div>
